import apiClient from "./base.service";

export default {
    async index(event, search) {
        if(search.token == "") {
            delete search.token;
        }
        return await apiClient.post(`/event/${event}/ticket`, search);
    },
    async arrive(event, id) {
        return await apiClient.put(`/event/${event}/ticket/${id}/arrive`);
    },
    async depart(event, id) {
        return await apiClient.put(`/event/${event}/ticket/${id}/depart`);
    }
}